import React, {Component} from "react";
import {UncontrolledTooltip} from "reactstrap";
import Datetime from "react-datetime";
import moment from "moment";
import {assignNested, deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import Select from "../../../local_node_modules/react-select";

class ExchangeDocumentInfo extends Component{
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            loading: false
        };
        this.onChange = this.onChange.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onChangeCountry = this.onChangeCountry.bind(this);
    }

    componentWillMount() {
        this.setState({additionalDocuments: this.props.additionalDocuments});
    }

    validateField(e, custom){
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = !!custom ? custom : validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    onChangeCountry(e){
        let additionalDocuments = deepCopyObject(this.state.additionalDocuments);

        additionalDocuments["country"] = e.value;

        this.state.additionalDocuments = additionalDocuments;
        this.props.listener(this.state.additionalDocuments);
    }

    onChange(e){
        let name = e.target.name;
        let value =e.target.value;
        let additionalDocuments = deepCopyObject(this.state.additionalDocuments);

        additionalDocuments[name] = value;

        this.state.additionalDocuments = additionalDocuments;
        this.props.listener(this.state.additionalDocuments);
    }

    onChangeDate(e, type, fullFieldName) {
        let value = e;
        let additionalDocuments = deepCopyObject(this.state.additionalDocuments);

        if (!(typeof value === "string")) {
            if (type === "datetime") {
                if (assignNested(additionalDocuments, fullFieldName, value.format("YYYY-MM-DDTHH:mm:ss"))) {
                    this.setState({additionalDocuments})
                }
            }
        } else {
            if (type === "datetime") {
                if (assignNested(additionalDocuments, fullFieldName, value)) {
                    this.setState({additionalDocuments})
                }
            }
        }
        this.state.additionalDocuments = additionalDocuments;
        this.props.listener(this.state.additionalDocuments);
    }

    render() {
        let additionalDocument = deepCopyObject(this.state.additionalDocuments);
        return (
            <div className="row">

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Gümrük Beyan Numarası</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('gumrukBeyan')}>
                            <input
                                className="form-control"
                                type="text"
                                id="gumrukBeyan"
                                value={additionalDocument.gumrukBeyan}
                                onChange={(e) => this.onChange(e)}
                                name="gumrukBeyan"/>
                            {this.validateMessage("gumrukBeyan") !== "" &&
                            <UncontrolledTooltip placement="right" target={"gumrukBeyan"} delay={0}>
                                {this.validateMessage("gumrukBeyan")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Gümrük Beyan Tarihi</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('gumrukBeyanTarihi')}>
                            <Datetime locale="tr"
                                      className=""
                                      input={true}
                                      onBlur={(momentObj) => this.validateField({
                                          target: {
                                              id: "gumrukBeyanTarihi",
                                              dataset: {'vdata': "datetime"},
                                              value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                          }
                                      })}
                                      inputProps={{id: 'gumrukBeyanTarihi'}}
                                      closeOnSelect={false}
                                      closeOnTab={false}
                                      value={moment(additionalDocument.gumrukBeyanTarihi, "YYYY-MM-DDTHH:mm:ss", true).isValid() ?
                                          moment(additionalDocument.gumrukBeyanTarihi).format("DD-MM-YYYY HH:mm:ss"):
                                          additionalDocument.gumrukBeyanTarihi}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm:ss"
                                      onChange={(e) => this.onChangeDate(e, "datetime", "gumrukBeyanTarihi")}/>
                            {this.validateMessage("gumrukBeyanTarihi") !== "" &&
                            <UncontrolledTooltip placement="right" target={"gumrukBeyanTarihi"} delay={0}>
                                {this.validateMessage("gumrukBeyanTarihi")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Döviz Beyan Tutanağı Numarası</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('dovizBeyan')}>
                            <input
                                className="form-control"
                                type="text"
                                id="dovizBeyan"
                                value={additionalDocument.dovizBeyan}
                                onChange={(e) => this.onChange(e)}
                                name="dovizBeyan"/>
                            {this.validateMessage("dovizBeyan") !== "" &&
                            <UncontrolledTooltip placement="right" target={"dovizBeyan"} delay={0}>
                                {this.validateMessage("dovizBeyan")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Döviz Beyan Tutanağı Tarihi</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('dovizBeyanTarihi')}>
                            <Datetime locale="tr"
                                      className=""
                                      input={true}
                                      onBlur={(momentObj) => this.validateField({
                                          target: {
                                              id: "dovizBeyanTarihi",
                                              dataset: {'vdata': "datetime"},
                                              value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                          }
                                      })}
                                      inputProps={{id: 'dovizBeyanTarihi'}}
                                      closeOnSelect={false}
                                      closeOnTab={false}
                                      value={moment(additionalDocument.dovizBeyanTarihi, "YYYY-MM-DDTHH:mm:ss", true).isValid() ?
                                          moment(additionalDocument.dovizBeyanTarihi).format("DD-MM-YYYY HH:mm:ss"):
                                          additionalDocument.dovizBeyanTarihi}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm:ss"
                                      onChange={(e) => this.onChangeDate(e, "datetime", "dovizBeyanTarihi")}/>
                            {this.validateMessage("dovizBeyanTarihi") !== "" &&
                            <UncontrolledTooltip placement="right" target={"dovizBeyanTarihi"} delay={0}>
                                {this.validateMessage("dovizBeyanTarihi")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Teyit Yazısı Numarası</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('gmTeyitYazisi')}>
                            <input
                                className="form-control"
                                type="text"
                                id="gmTeyitYazisi"
                                value={additionalDocument.gmTeyitYazisi}
                                onChange={(e) => this.onChange(e)}
                                name="gmTeyitYazisi"/>
                            {this.validateMessage("gmTeyitYazisi") !== "" &&
                            <UncontrolledTooltip placement="right" target={"gmTeyitYazisi"} delay={0}>
                                {this.validateMessage("gmTeyitYazisi")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Teyit Yazısı Tarihi</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('gmTeyitYazisiTarihi')}>
                            <Datetime locale="tr"
                                      className=""
                                      input={true}
                                      onBlur={(momentObj) => this.validateField({
                                          target: {
                                              id: "gmTeyitYazisiTarihi",
                                              dataset: {'vdata': "datetime"},
                                              value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                          }
                                      })}
                                      inputProps={{id: 'gmTeyitYazisiTarihi'}}
                                      closeOnSelect={false}
                                      closeOnTab={false}
                                      value={moment(additionalDocument.gmTeyitYazisiTarihi, "YYYY-MM-DDTHH:mm:ss", true).isValid() ?
                                          moment(additionalDocument.gmTeyitYazisiTarihi).format("DD-MM-YYYY HH:mm:ss"):
                                          additionalDocument.gmTeyitYazisiTarihi}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm:ss"
                                      onChange={(e) => this.onChangeDate(e, "datetime", "gmTeyitYazisiTarihi")}/>
                            {this.validateMessage("gmTeyitYazisiTarihi") !== "" &&
                            <UncontrolledTooltip placement="right" target={"gmTeyitYazisiTarihi"} delay={0}>
                                {this.validateMessage("gmTeyitYazisiTarihi")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Belge Türü</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('documentTypeCode')}>
                            <input className="form-control"
                                   id="documentTypeCode"
                                   name="documentTypeCode"
                                   onChange={(e) => this.onChange(e)}
                                   value={additionalDocument.documentTypeCode}
                                   type="text"/>
                            {this.validateMessage("documentTypeCode") !== "" &&
                            <UncontrolledTooltip placement="right" target={"documentTypeCode"} delay={0}>
                                {this.validateMessage("documentTypeCode")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Geldiği Ülke</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass("country")}>
                            <Select
                                id="country"
                                value={additionalDocument.country}
                                clearable={false}
                                noResultsText="Sonuç yok"
                                clearValueText="Temizle"
                                placeholder="Seçiniz..."
                                onChange={(e) => this.onChangeCountry(e)}
                                options={this.props.countries.map(country => ({
                                    value: country.longNameTr,
                                    label: country.longNameTr
                                }))}
                            />
                            {this.validateMessage("country") !== "" &&
                            <UncontrolledTooltip placement="right" target={"country"} delay={0}>
                                {this.validateMessage("country")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">Geliş Nedeni</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('reason')}>
                            <input className="form-control"
                                   id="reason"
                                   name="reason"
                                   onChange={(e) => this.onChange(e)}
                                   value={additionalDocument.reason}
                                   type="text"/>
                            {this.validateMessage("reason") !== "" &&
                            <UncontrolledTooltip placement="right" target={"reason"} delay={0}>
                                {this.validateMessage("reason")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 row">
                    <div className="col-sm-6  col-form-label">
                        <label className="col-form-label">İstatistik Numarası</label>
                    </div>
                    <div className="col-sm-6" style={{maxWidth: "none"}}>
                        <div className={"form-group" + this.validateClass('statisticNo')}>
                            <input className="form-control"
                                   id="statisticNo"
                                   name="statisticNo"
                                   onChange={(e) => this.onChange(e)}
                                   value={additionalDocument.statisticNo}
                                   type="text"/>
                            {this.validateMessage("statisticNo") !== "" &&
                            <UncontrolledTooltip placement="right" target={"statisticNo"} delay={0}>
                                {this.validateMessage("statisticNo")}
                            </UncontrolledTooltip>}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
export default ExchangeDocumentInfo;